import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-p0003601-speed-choice',
  templateUrl: './p0003601-speed-choice.component.html',
  styleUrls: ['./p0003601-speed-choice.component.scss'],
  imports: [
    IonButton,
    IonContent,
    IonFooter,
    IonLabel,
    TranslatePipe,
    IonItem,
    IonList,
  ],
})
export class P0003601SpeedChoiceComponent {
  private modalController = inject(ModalController);

  @Input() value: number = 0;
  constructor() {}

  async select(value: number) {
    await this.modalController.dismiss({ value: value });
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss();
  }
}
